(function(){
  const CUTOFFS={
    '2026-11-30':'2026-11-20',
    '2026-12-07':'2026-11-27',
    '2026-12-14':'2026-12-04',
    '2026-12-21':'2026-12-11'
  };

  function portugalDateKey(){
    const parts=new Intl.DateTimeFormat('en-CA',{
      timeZone:'Europe/Lisbon',
      year:'numeric',month:'2-digit',day:'2-digit'
    }).formatToParts(new Date());
    const map={};
    parts.forEach(p=>{if(p.type!=='literal')map[p.type]=p.value});
    return `${map.year}-${map.month}-${map.day}`;
  }

  function applyCutoffs(root=document){
    const today=portugalDateKey();
    root.querySelectorAll('#delivery-week').forEach(select=>{
      Object.entries(CUTOFFS).forEach(([value,cutoff])=>{
        if(today>=cutoff){
          const option=Array.from(select.options).find(o=>o.value===value);
          if(option){
            if(select.value===value)select.value='';
            option.remove();
          }
          const custom=select.parentElement?.querySelector(`.dohte-week-dropdown__option[data-value="${value}"]`);
          if(custom)custom.remove();
        }
      });
    });
  }

  function boot(){applyCutoffs(document)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  document.addEventListener('shopify:section:load',e=>applyCutoffs(e.target));
  setInterval(()=>applyCutoffs(document),15000);
})();
